import React from 'react'
import CanonicalImg from '../../Img'

// COMPAT SHIM (task #67). Wraps the canonical <Img>. `image` is a pre-resolved
// ResolvedImage descriptor (the walker resolves the customImage's inner `.image`
// server-side). `desktopWidthPx` becomes a `sizes` hint; the browser picks the
// right variant from the descriptor's full srcSet. No manifest import, no JS blur.
function ProgressiveCustomImage({ image, alt, desktopWidthPx, className }) {
  if (!image || typeof image !== 'object') return null
  const sizes = desktopWidthPx ? `(min-width: 992px) ${desktopWidthPx}px, 100vw` : '100vw'
  return (
    <CanonicalImg
      image={image}
      alt={alt}
      sizes={sizes}
      layout="responsive"
      objectFit="contain"
      className={className}
    />
  )
}

export default ProgressiveCustomImage
